const state = {
    showVerticalMenu: false,
    menuRoutes: '',
    client: {},
    legalFormSupport: false,
    editing: false,
    searching: false,
    creating: false,
    personId: null,
    personType: '',
    linkType: '',
}

const mutations = {
    SET_MENU_ROUTES(state, menuRoutes) {
        state.menuRoutes = menuRoutes
    },

    SHOW_VERTICAL_MENU(state) {
        state.showVerticalMenu = true
    },

    HIDE_VERTICAL_MENU(state) {
        state.showVerticalMenu = false
    },

    SET_CLIENT(state, data) {
        state.client = data
    },
    RESET_CLIENT(state) {
        state.client = null
        state.legalFormSupport = false
    },

    SET_LINK_TYPE(state, type) {
        state.linkType = type
    },
    RESET_LINK_TYPE(state) {
        state.linkType = ''
    },
    SET_PERSON_TYPE(state, type) {
        state.personType = type
    },
    RESET_PERSON_TYPE(state) {
        state.personType = ''
    },
    SET_PERSON_ID(state, id) {
        state.personId = id
    },
    RESET_PERSON_ID(state) {
        state.personId = null
        state.personType = ''
    },

    SET_LEGAL_FORM_SUPPORT(state, status) {
        state.legalFormSupport = status
    },

    SHOW_SEARCH(state) {
        state.searching = true
        state.editing = false
        state.creating = false
    },
    SHOW_EDIT(state) {
        state.searching = false
        state.editing = true
        state.creating = false
    },
    SHOW_CREATE(state) {
        state.searching = false
        state.editing = false
        state.creating = true
    },
    RESET_STATUS(state) {
        state.searching = false
        state.editing = false
        state.creating = false
        state.personType = ''
    },
}

const actions = {
    async getRoutes({commit}) {
        try {
            const response = await axios.get('/legal/routes')
            commit('SET_MENU_ROUTES', response.data)
        } catch (error) {
            // console.log(error)
            console.log('menuRoutes not loaded')
        }
    },

    async getClientData({commit}, id) {
        // console.log('get client: ',id)
        try {
            const response = await axios.get(`/legal/clients/${id}`)
            // console.log('response:', response.data.data)
            commit('SET_CLIENT', response.data.data)
            // commit('SET_LEGAL_FORM_SUPPORT', ['EURL','SARL','SAS','SASU'].includes(response.data.data.legal_form))
            commit('SET_LEGAL_FORM_SUPPORT', true)
        } catch (error) {
            console.log('client data not loaded')
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
